module.exports = __webpack_public_path__ + "static/media/04.06ef7457.jpeg";